import DEFAULT from './default';
import BG from './bluegray';


const themes = {
    DEFAULT,
    BG: BG,
};

export default themes;